import type { PayloadAction } from '@reduxjs/toolkit'

export const createSetter =
	<Slice, K extends keyof Slice = keyof Slice>(key: keyof Slice) =>
	(state: Slice, { payload }: PayloadAction<Slice[K]>) => {
		state[key] = payload
	}
